<template>
  <div class="columns">
    <div class="column">
      <div class="columns is-mobile is-vcentered">
        <div class="column">
          <h1 class="title font-16 has-text-darkblue font-w-600">Berita Kampus</h1>
        </div>
      </div>

      <div class="box is-boxed-3" style="border: none;">
        <div v-if="!isEmpty(news)">
          <div class="columns is-mobile is-vcentered" v-for="n in news" :key="n.id">
            <div class="column">
              <p class="title font-14 has-text-darkblue">
                <strong style="font-weight: bold;">
                  <a @click.prevent="toDetailPost(n)" class="has-text-darkblue">{{ n.title }}</a>
                </strong>
              </p>
              <p class="subtitle font-12 has-text-primary2 font-w-500">{{ date_humanize(n.updatedAt) }}</p>
            </div>
          </div>
        </div>

        <p v-else class="has-text-grey font-14">Tidak ada berita.</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { UNIVERSITY_NEWS } from '~/consts';

export default {
  mounted() {
    this.getNews();
  },

  computed: {
    ...mapState({
      auth: state => state.auth,
    }),
  },

  data() {
    return {
      loading_get_news: false,
      news: [],
      dataProvider: {
        criterion: [],
        page: {
          count: 0,
          current: 1,
          limit: 3,
          next: 0,
          previous: 0,
          total: 0
        },
        sort: [{criteria: 'updated_at', order: 'desc'}]
      },
    }
  },

  methods: {
    toDetailPost(n) {
      // this.$store.commit('setState', {key: 'university_news_id', value: n.id})
      this.$router.push({ path: `/panel/university/news/${n.id}` })
    },
    getNews() {
      const vm = this;

      vm.loading_get_news = true;

      this.$axios.post(UNIVERSITY_NEWS.GET_PUBLISHED, {
        dataProvider: JSON.stringify(vm.dataProvider)
      }).then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          vm.news = collect(vm.news).merge(data.data.data).toArray();
          vm.dataProvider = data.data.dataProvider

          if (!vm.isEmpty(vm.news)) {
            vm.show = true;
          }
        }

        vm.loading_get_news = false;
      }).catch(() => {
        vm.loading_get_news = false;
      })
    },
  }
}
</script>
